import {Params} from 'react-router'

export const ROOT = '/'
const PLANT_ROOT = '/:plantId'
export const DASHBOARD = `${PLANT_ROOT}/dashboard`
export const PLANT_SECTION = `${PLANT_ROOT}/section/:sectionId`
export const PLANT_SUB_SECTION = `${PLANT_ROOT}/subsection/:sectionId/:topicId`
export const ACTIONS = `${PLANT_ROOT}/actions`
export const REF_LINKS = `${PLANT_ROOT}/reflinks`
export const COMPARATIVE_ANALYSIS = `${PLANT_ROOT}/comparative-analysis`
export const ERROR_403 = '/error403'

export const plantRoutes = [
  DASHBOARD,
  PLANT_SECTION,
  PLANT_SUB_SECTION,
  ACTIONS,
  REF_LINKS,
  COMPARATIVE_ANALYSIS
]

export interface PathParameters extends Params {
  plantId?: string
  sectionId?: string
  topicId?: string
}
